__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/aa9af63/_next/";